// attestation-type.enum.ts
export enum AttestationType {
  ATTASSU = "ATTASSU",
  ATTTELETRAVAIL = "ATTTELETRAVAIL",
  ATTSCO = "ATTSCO",
  ATTLOCSALLE = "ATTLOCSALLE",
  ATTLOCVAC = "ATTLOCVAC",
  ATTRCVP = "ATTRCVP",
}
